export default {
  name: 'table-column-icon',
  props: {
    index: {
      type: Number,
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    stylingClasses: {
      type: Array,
      default: []
    }
  },
  data () {
    return {

    }
  },
  methods: {
    onExpand () {
      this.$emit('click', this.index)
    }
  }
}
